var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: "small-12 column d-flex flex-column align-items-center" },
    [
      _c(
        "div",
        {
          class:
            "dropflex position-relative config-item w-100 my-auto position-relative",
        },
        [
          _c("div", { staticClass: "row my-children-2" }, [
            _c("div", { staticClass: "small-12 column" }, [
              _c("div", { staticClass: "config-item__info d-inline-flex" }, [
                _c("label", [_vm._v(_vm._s(_vm.option.name))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "config-group-outline px-prj2 py-prj px-3@large border",
                },
                [
                  _vm._l(
                    _vm.option.auspraegungen,
                    function (auspraegung, index) {
                      return [
                        _c(
                          "div",
                          {
                            key: "div" + auspraegung.id,
                            staticClass:
                              "config-item__info d-inline-flex py-prj2 py-prj3@large w-100",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.current,
                                  expression: "current",
                                },
                              ],
                              attrs: {
                                type: "radio",
                                name: auspraegung.name,
                                id: auspraegung.id,
                              },
                              domProps: {
                                value: auspraegung.id,
                                checked: _vm._q(_vm.current, auspraegung.id),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.current = auspraegung.id
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "label-aligned font-weight-bold w-50",
                                attrs: { for: auspraegung.id },
                              },
                              [
                                _c("span", { staticClass: "mainlabel" }, [
                                  _vm._v(_vm._s(auspraegung.name)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.url(auspraegung),
                                  title: _vm.title(auspraegung),
                                  download: "",
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "svg-icon icon-download mr-2",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 11.92 12.76",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M.75 12.76a1 1 0 01-.51-.28.85.85 0 01-.24-.6V9a.85.85 0 011.19-.81.84.84 0 01.54.84v1.82c0 .14 0 .14.13.14h8.2c.13 0 .13 0 .13-.13V9.09a.87.87 0 01.36-.75.82.82 0 01.85-.09.8.8 0 01.51.67 1.21 1.21 0 010 .19v2.72a.89.89 0 01-.24.66.94.94 0 01-.43.25h-.08z",
                                        fill: "#3a3a39",
                                        "fill-rule": "evenodd",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M6.19 0a2.43 2.43 0 01.37.16.84.84 0 01.38.73v5.42l.22-.21c.3-.3.6-.61.91-.91a.85.85 0 011.07-.11.87.87 0 01.34 1 1.26 1.26 0 01-.35.47L7.72 8 6.65 9a.88.88 0 01-1.24 0L3.78 7.34c-.33-.33-.67-.66-1-1a.8.8 0 01-.13-.85.85.85 0 01.69-.49 1 1 0 01.85.35c.31.32.62.62.93.93l.08.07V1a.93.93 0 01.21-.69.87.87 0 01.46-.31H6z",
                                        fill: "#3a3a39",
                                        "fill-rule": "evenodd",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "figure",
                              {
                                staticClass:
                                  "content-list__figure embed-responsive embed-responsive-1/1 position-relative",
                              },
                              [
                                _vm.url(auspraegung)
                                  ? _c("PdfPreview", {
                                      attrs: { url: _vm.url(auspraegung) },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        index < _vm.option.auspraegungen.length - 1
                          ? _c("hr", {
                              key: "hr" + auspraegung.id,
                              staticClass: "m-0 bg-shade",
                            })
                          : _vm._e(),
                      ]
                    }
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _vm.option.currentInfo.msgType === "INFO"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-small mt-prj text-info d-flex line-height-12 align-items-center",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass:
                            "mr-2 svg-icon flex-child-fix position-relative t-1px",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            x: "0",
                            y: "0",
                            viewBox: "0 0 36 36",
                            "xml:space": "preserve",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z",
                              fill: "#62b982",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              id: "XMLID_1_",
                              d: "M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z",
                              fill: "#fff",
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.option.currentInfo.msgType === "ERROR"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-small mt-prj text-error d-flex line-height-12 align-items-center",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass:
                            "mr-2 svg-icon flex-child-fix position-relative t-1px",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 36 36",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "18",
                              cy: "18",
                              r: "18",
                              fill: "#e94d47",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                              fill: "#fff",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.option.currentInfo.text) +
                          "\n              "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }